import React, { Component } from "react";
import PropTypes from "prop-types";

class CheckBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: this.props.isChecked,
      value: "",
    };
  }

  static defaultProps = {
    value: "",
    label: "",
    onChange: () => {},
    isChecked: false,
    isOrion: false,
    isDisabled: false,
  };

  static propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    isChecked: PropTypes.bool,
    gridClass: PropTypes.string,
    isOrion: PropTypes.bool,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.isChecked !== prevState.isChecked) {
      return {
        isChecked: nextProps.isChecked,
      };
    }
    return null; // No state updates
  }

  onChange = (event) => {
    const { checked, value } = event.target;

    this.setState({
      isChecked: checked,
      value: checked ? value : "", // Set value only if checked
    });

    if (this.props.onChange && typeof this.props.onChange === "function") {
      this.props.onChange(event);
    }
  };

  clearCheckBox = () => {
    this.setState({ isChecked: false });
  };

  render() {
    const { value, className, label, isDisabled } = this.props;

    return (
      <div className={this.props.gridClass}>
        <div className="NewsletterFooter">
          <div className="NFLabel">
            <label className={`labelBox ${this.state.isChecked ? "checked" : ""} ${className}`}>
              <input
                type="checkbox"
                value={value}
                onChange={this.onChange}
                className={`${className} checkbox`}
                checked={this.state.isChecked}
                disabled={isDisabled}
              />
              <span className={`checkbokCheckBefore ${this.props.classNames || ""}`}></span>
              <span className="checkbokCheckAfter"></span>
              <span className="NLText">{label}</span>
            </label>
          </div>
        </div>
        <style>
          {`
          .newsletter-card-checkbox {
            display:none;
          }
          .newsletter-card-checkbox .NLText {
            padding:0;
            position:relative;
          }
          .checkbox {
            padding: 0;
            height: initial;
            width: initial;
            margin-bottom: 0;
            cursor: pointer;
          }
          .labelBox, .NewsletterFooter{
            position: relative;
            cursor: pointer;
            font-size: 14px;
          }
          .NLText{padding-left: 15px;}
          .labelBox{display: flex;}
          .labelBox .checkbokCheckBefore {
            background-color: #fff;
            border: 2px solid #0079bf;
            padding: 8px;
            display: inline-block;
            position: relative;
            vertical-align: middle;
            cursor: pointer;
            margin-right: 0px;
            top: -2px;
            height: 16px;
            width: 16px;
          }
          .labelBox .checkbokCheckAfter {
            position: absolute;
            top: 1px;
            left: 7px;
            width: 6px;
            height: 11px;
            border: solid #0079bf;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            display: none;
          }
          .labelBox input {
            -webkit-appearance: none;
          }
          .labelBox input:checked ~ .checkbokCheckAfter {
            display: block;
          }
          .labelBox input:focus {
            outline:none;
          }          
          .feedbackCheck .NFLabel { left: 50%; }
          .feedbackCheck .NLText{ display: none; }

          @media (max-width: 575px){
            .NewsletterFooter p {
              font-size: 12px;
            }
          }
        `}
        </style>
      </div>
    );
  }
}

export default CheckBox;
